import cx from "classnames";
import { get, isArray } from "lodash";
import {
  MDBAlert,
  MDBBtn,
  MDBInputGroup,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBSpinner
} from "mdbreact";
import moment from "moment";
import React, { Component } from "react";
import Barcode from "react-barcode";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PKHBtn from "~/components/common/atoms/Button";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import { resetPayment } from "~/store/payment/paymentAction";
import {
  addScheduleRepayment,
  checkRepayment
} from "~/store/totalData/actions";
import { Android_MEDPRO, BASE_URL, IOS_MEPRO } from "~/utils/constants";
import { getInfoPatient } from "~/utils/flowRouting";
import { routerByPartnerId } from "~/utils/func";
import partnerId from "~/utils/partner";
import BottomNavigationNews from "../../atoms/BottomNavigationNews";
import styles from "./style.module.scss";

const QRCode = require("qrcode.react");
class MedicalBillPrintNews extends Component {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(this.props.location.search);
    const mpTransaction = urlParams.get("mpTransaction");
    this.state = {
      mpTransaction,
      shareToPay: true,
      countdown: [
        {
          hours: "00",
          minutes: "00",
          seconds: "00"
        }
      ],
      onCountDown: false
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const mpTransaction = urlParams.get("mpTransaction");
    const transactionId = get(this.props.match.params, "code");

    const handingTime = value => {
      return value < 10 ? "0" + value : value;
    };

    this.interval = setInterval(() => {
      const { paymentInformation } = this.props;

      const mapTimes = paymentInformation?.map((bill, i) => {
        const notPaymentYetInfo = get(
          bill,
          "bookingInfo.notPaymentYetInfo",
          ""
        );
        const then = moment(notPaymentYetInfo.countdown).utc();

        if (notPaymentYetInfo.countdown) {
          const now = moment().utc();

          const time = then.diff(now);
          const seconds = Math.floor((time / 1000) % 60);
          const minutes = Math.floor((time / 1000 / 60) % 60);
          const hours = Math.floor((time / (1000 * 60 * 60)) % 24);

          if (time <= 0) {
            this.props.getBookingInfo(
              mpTransaction || transactionId,
              "payment"
            );
            clearInterval(this.interval);

            return {
              hours: "00",
              minutes: "00",
              seconds: "00"
            };
          } else {
            return {
              hours: handingTime(hours),
              minutes: handingTime(minutes),
              seconds: handingTime(seconds)
            };
          }
        } else {
          return null;
        }
      });

      this.setState({
        countdown: mapTimes
      });
    }, 1000);
  }

  valueShareToPay() {
    const { paymentInformation } = this.props;
    const id = get(paymentInformation, "bookingInfo.id");
    const rs = BASE_URL + "/thanh-toan-ho/" + id;
    return rs;
  }

  copyTexthandler = async url => {
    openToast("Đường dẫn đã được sao chép.");
    if (typeof navigator.clipboard === "undefined") {
      var textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (err) { }

      document.body.removeChild(textArea);
      return;
    }
    navigator.clipboard.writeText(url);
    this.toggleShareToPay();
  };

  toggleShareToPay = () => {
    this.setState({
      shareToPay: !this.state.shareToPay
    });
  };

  renderModalShareToPay = () => {
    const { shareToPay } = this.state;
    const { paymentInformation } = this.props;
    const status = get(paymentInformation, "bookingInfo.status");

    const share = Number(status) === 6 && shareToPay;
    return (
      <MDBModal
        backdrop={false}
        isOpen={share}
        toggle={this.toggleShareToPay}
        style={{ witdh: "70%" }}
      >
        <MDBModalHeader
          className={cx(
            "text-center text-uppercase  text-white py-2",
            partnerId === "minhanh" ? "bg-danger" : "bg-primary"
          )}
          toggle={this.toggleShareToPay}
          tag="h6"
        >
          <p className="m-0"> Thanh Toán hộ</p>
        </MDBModalHeader>
        <MDBModalBody style={{ fontSize: "0.875rem" }}>
          <p>
            <em>
              Quý bệnh nhân có thể nhờ người thân hoặc bạn bè để thanh toán
              phiếu khám bệnh. Phiếu khám bệnh chỉ <b>hợp lệ</b> sau khi
              <b> thanh toán thành công</b>.
            </em>
          </p>
          <p className=" text-center">
            <b>Sao chép và chia sẻ liên kết bên dưới để nhờ thanh toán hộ</b>
          </p>
          <MDBInputGroup
            value={this.valueShareToPay()}
            size="sm"
            containerClassName="mb-3"
            disabled
            append={
              <MDBBtn
                outline
                className="m-0 px-3 py-2 z-depth-0"
                onClick={() => {
                  this.copyTexthandler(this.valueShareToPay());
                }}
              >
                Sao chép
              </MDBBtn>
            }
          />
        </MDBModalBody>
      </MDBModal>
    );
  };

  handleRePayment = () => {
    const { paymentInformation: bill } = this.props;
    const bookingInfo = get(bill, "bookingInfo");
    const partnerId = get(bill, "bookingInfo.partnerId");
    this.props.checkRepayment(true);
    this.props.addScheduleRepayment(bookingInfo);
    if (this.props.IsAuthenticated) {
      this.props.resetPayment();
      const route = routerByPartnerId("/xac-nhan-thong-tin", partnerId);
      history.push(route);
    } else {
      history.push(`/${bookingInfo.partnerId}/hinh-thuc-thanh-toan`);
    }
  };

  renderMedicalBill = () => {
    let bills = [];

    bills = isArray(this.props?.paymentInformation)
      ? this.props?.paymentInformation
      : [this.props?.paymentInformation];

    return bills?.map((bill, i) => {
      let bookingDate, bookingTime, bookingTimeBig;
      const partner = get(bill, "bookingInfo.partner");

      const totalPaymentMessage = get(
        bill,
        "bookingInfo.totalPaymentMessage",
        ""
      );
      const treeId = get(bill, "bookingInfo.treeId", "");

      const transactionId = get(bill, "bookingInfo.transactionId");
      const id = get(bill, "bookingInfo.id");
      const bookingCode = get(bill, "bookingInfo.bookingCode");
      const partnerId = get(bill, "bookingInfo.partnerId");
      const date = get(bill, "bookingInfo.date", "");
      if (date) {
        bookingDate = moment(date).format("DD/MM/YYYY");
        bookingTime = moment(date).format("HH:mm");
        bookingTimeBig = moment(date).format("HH:mm");
      } else {
        bookingDate = get(bill, "bookingInfo.waitingConfirmDate");
        bookingTime = get(bill, "bookingInfo.waitingConfirmDate");
        bookingTimeBig = "";
      }
      const serviceName = get(bill, "bookingInfo.service.name", "");
      const addonServices = get(bill, "bookingInfo.addonServices", "");
      const subjectName = get(bill, "bookingInfo.subject.name", "");
      const doctorName = get(bill, "bookingInfo.doctor.name", "");

      const room = get(bill, "bookingInfo.room", "");
      const section = get(bill, "bookingInfo.section", "");

      const patient = get(bill, "patientInfo", {});
      const { fullName, birthdate } = getInfoPatient(patient);
      const code = get(bill, "bookingInfo.displayCodeBooking", "");
      const insuranceCode = get(bill, "bookingInfo.insuranceCode");
      const price = get(bill, "bookingInfo.service.priceText", "");
      const description = get(bill, "checkInRoom.description", "");

      const status = get(bill, "bookingInfo.status", 1);
      const bookingNote = get(bill, "bookingInfo.bookingNote", null);
      const bookingNumber = get(bill, "bookingInfo.sequenceNumber", "");
      const titleBookingTime =
        partnerId === "trungvuong"
          ? "Giờ tiếp nhận dự kiến"
          : "Giờ khám dự kiến";
      const titleBooking = get(bill, "bookingInfo.description", "");
      // const canRepayment = get(bill, "bookingInfo.canRepayment", true);
      const awaitMessage = get(bill, "bookingInfo.awaitMessage", "");
      const classNumber = styles.number;
      const classGray = styles.gray;
      const classCX = cx({
        [classNumber]: true,
        [classGray]: status === -2
      });
      const classGreen = styles.greenNote;
      const classRed = styles.redNote;
      const classGrey = styles.greyNote;
      const classTimeNote = cx({
        [classGreen]: true,
        [classRed]: status === 0 || status === 6,
        [classGrey]: status === -2
      });

      const typeCode = e => {
        switch (e?.type) {
          case "barcode":
            return (
              <React.Fragment>
                {e?.value && <p>{e?.title}</p>}
                {e?.isNew && (
                  <p className={styles.isNewUserTxt}>{e?.message}</p>
                )}
                {e?.value && (
                  <Barcode
                    value={e?.value || "#"}
                    format="CODE128"
                    height={50}
                    width={1}
                    fontSize={14}
                  />
                )}
              </React.Fragment>
            );
          case "qrcode":
            return (
              <React.Fragment>
                {e?.value && <p>{e?.title}</p>}
                {e?.isNew && (
                  <p className={styles.isNewUserTxt}>{e?.message}</p>
                )}
                {e?.value && (
                  <QRCode fgColor="#000000" size={90} value={e?.value} />
                )}
                {treeId === "CLS" && <p className="mt-2">{e?.value}</p>}
              </React.Fragment>
            );
          default:
            return null;
        }
      };
      const CustomLine = ({ top, bottom, normal = true }) => {
        return (
          <div
            className={cx(
              styles.line,
              top && styles.top,
              bottom && styles.bottom,
              normal && styles.normal
            )}
          >
            <div className={styles.circle} />
            <div className={styles.dashed} />
            <div className={styles.circle} />
          </div>
        );
      };
      const checkHiddenShareToPay = () => {
        if (status !== 6) return "d-none";
      };
      // const canRepayment = get(bill, "bookingInfo.canRepayment", true);
      const notPaymentYetInfo = get(bill, "bookingInfo.notPaymentYetInfo", "");
      const isPhieuHen = this.props.location.pathname.includes(
        "/phieu-kham-benh/chi-tiet/"
      );
      const totalMessageExtra = get(bill, "bookingInfo.totalMessageExtra", "");
      const patientCode = get(bill, "bookingInfo.patient.patientCode", "");
      const cancelMessage = get(bill, "bookingInfo.cancelMessage", "");

      const { countdown } = this.state;

      const countdownString = `${countdown[i]?.minutes}:${countdown[i]?.seconds}`;

      const checkInfoBenhNhan = () => {
        if (treeId !== "CLS") {
          if (this.state.mpTransaction && status === 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      };

      const checkInfoBenhNhanCLS = () => {
        if (treeId === "CLS") {
          if (this.state.mpTransaction && status === 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      };

      // console.log("check :>> ", {
      //   checkInfoBenhNhanCLS: checkInfoBenhNhanCLS(),
      //   status
      // });

      const thongTinBenhNhan = (
        <>
          <li>
            <span className={styles.column_left}>Bệnh nhân:</span>
            <b>{fullName}</b>
          </li>

          <li>
            <span className={styles.column_left}>Ngày sinh:</span>
            <p>{birthdate}</p>
          </li>

          {patientCode && (
            <li>
              <span className={styles.column_left}>Mã bệnh nhân:</span>
              <b>{patientCode}</b>
            </li>
          )}
        </>
      );

      return (
        <div className={styles.bills} key={id}>
          <div
            key={id}
            id="print"
            className={styles.print}
            ref={el => (this.componentRef = el)}
          >
            <CustomLine top />
            {/* Quảng bá medpro */}
            <div className={styles.public_medpro}>
              <p>PHIẾU KHÁM BỆNH TRỰC TUYẾN</p>
              <img
                src="https://bo-api.medpro.com.vn/static/images/medpro/web/header_logo.svg"
                alt="MEDPRO"
              />
            </div>
            {/* Thông tin bệnh viện: logo, tên, địa chỉ */}
            <div className={styles.title_hospital}>
              {/* status === 0 || status === 6 ? null : (
                <>
                  <p className={styles.sub_title}>
                    PHIẾU {treeId === "CLS" ? "CẬN LÂM SÀNG" : "KHÁM BỆNH"}
                  </p>
                </>
              ) */}
              <p className={styles.nameParner}>{partner?.name}</p>
              <p className={styles.addressParner}>{partner?.address}</p>
            </div>
            {/* render lại QRcode hay BarCode theo phiếu BE trả về */}

            {status === 0 || status === 6 || status === -2 ? null : (
              <div className={cx(styles.bar_code)}>{typeCode(code)}</div>
            )}

            {/* nếu có thanh toán hộ sẽ xuất hiện nút này */}
            {status === 0 || status === 6 ? null : (
              <div className={cx(styles.time_note)}>
                <span className={cx(styles.titleBooking, classTimeNote)}>
                  {titleBooking}
                </span>
                <span className={cx(checkHiddenShareToPay(), styles.btnShare)}>
                  <Link to="#" onClick={() => this.toggleShareToPay()}>
                    Thanh toán hộ
                  </Link>
                </span>
                {cancelMessage && (
                  <span className={styles.cancelMessage}>{cancelMessage}</span>
                )}
              </div>
            )}

            {/* nếu phiếu chưa được thanh toán hoặc thanh toán hộ thì xuất hiện thanh toán lại */}
            {(status === 0 || status === 6) && (
              <div className={styles.thanhToanLai}>
                <div className={styles.identified}>
                  <img
                    src={require("~/assets/img/desktop/icon/thanhToanThatBai.svg")}
                    alt="thanhToanThatBai"
                  />
                  <p className={styles.status}>
                    {status === 0 && !isPhieuHen
                      ? "Giao dịch thất bại!"
                      : "Chưa thanh toán"}
                  </p>
                </div>

                <div className={styles.message}>
                  <img
                    src={require("~/assets/img/desktop/icon/notipayment.svg")}
                    alt="notipayment"
                  />
                  <div
                    className={styles.txt}
                    dangerouslySetInnerHTML={{
                      __html: notPaymentYetInfo?.notPaymentYetMessage
                    }}
                  />
                </div>

                <div className={styles.timesDiv}>
                  <p className={styles.txt}>Thời gian thanh toán còn lại</p>
                  <p className={styles.time}>{countdownString}</p>
                </div>

                {/*
                <div className={styles.groupBtn}>
                  <PKHBtn
                    smallCus
                    rounded
                    color="light-blue"
                    className={cx(styles.button)}
                    onClick={this.handleRePayment}
                    icon={
                      <img
                        src={require("~/assets/img/desktop/icon/repayment.svg")}
                        alt="repayment"
                      />
                    }
                    iconPosition="right"
                  >
                    Thanh toán lại
                  </PKHBtn>

                  <PKHBtn
                    smallCus
                    rounded
                    color="deep-orange"
                    className={cx(styles.button)}
                    onClick={() => this.toggleShareToPay()}
                    iconPosition="right"
                    icon={
                      <img
                        src={require("~/assets/img/desktop/icon/sharetopay.svg")}
                        alt="sharetopay"
                      />
                    }
                  >
                    Nhờ thanh toán
                  </PKHBtn>
                </div> */}

                <div className={styles.support}>
                  <p>
                    Trong quá trình thanh toán gặp khó khăn, vui lòng gọi đến
                    Tổng đài CSKH để được hỗ trợ.
                  </p>

                  <PKHBtn
                    paddingCus="10px 10px"
                    outline
                    rounded
                    className={cx(styles.button)}
                    icon={
                      <img
                        src={require("~/assets/img/desktop/icon/phone.svg")}
                        alt="phone"
                      />
                    }
                  >
                    <a href={`tel:${notPaymentYetInfo?.hotlineInfo}`}>
                      Tổng đài {notPaymentYetInfo?.hotlineInfo}
                    </a>
                  </PKHBtn>
                </div>
              </div>
            )}
            {/* text: số tiền bệnh viện thanh toán giúp */}
            {(status === 2 || status === 1 || status === -2) &&
              totalPaymentMessage && (
                <div className={styles.totalPaymentMessage}>
                  <span className={styles.Message}>{totalPaymentMessage}</span>
                  <span className={styles.MessageExtra}>
                    {totalMessageExtra}
                  </span>
                </div>
              )}

            {treeId !== "CLS" && status !== 0 && status !== 6 && <CustomLine />}

            {/* Sô thứ tự, thời gian dự kiến hoặc đợi */}
            {status === 0 || status === 6 || status === -2 ? null : (
              <React.Fragment>
                {awaitMessage !== "" ? (
                  <div className={styles.awaitMessage}>
                    <p>{awaitMessage}</p>
                    <MDBSpinner small yellow className={styles.spin} />
                  </div>
                ) : (
                  <div className={classCX}>
                    <p className={cx(styles.txtNum, classCX)}>
                      {bookingNumber
                        ? "Số thứ tự tiếp nhận"
                        : "Giờ tiếp nhận dự kiến"}
                    </p>
                    <p> {bookingNumber || bookingTimeBig}</p>
                  </div>
                )}
              </React.Fragment>
            )}

            {!checkInfoBenhNhanCLS() || status === -2 || status === 0 ? null : (
              <div className={styles.list_detail}>
                <ul>
                  {bill?.patient?.tempPatientCode && (
                    <li className={styles.red}>
                      <span className={styles.column_left}>
                        Ghi chú số hồ sơ:
                      </span>
                      <b>{bill?.patient?.tempPatientCode}</b>
                    </li>
                  )}

                  {bill?.bookingInfo?.bookingInternalId && (
                    <li>
                      <span className={styles.column_left}>
                        Mã phiếu chỉ định:
                      </span>
                      <p className={styles.value}>
                        {bill?.bookingInfo?.bookingInternalId}
                      </p>
                    </li>
                  )}

                  {bill?.payment?.paymentTime && (
                    <li>
                      <span className={styles.column_left}>
                        Thời gian thanh toán:
                      </span>
                      <p className={styles.value}>
                        {bill?.payment?.paymentTime}
                      </p>
                    </li>
                  )}
                </ul>
              </div>
            )}

            {treeId === "CLS" && status !== 0 && <CustomLine />}

            {/* phần thông tin phiếu cận lâm sàn */}
            {checkInfoBenhNhanCLS() && (
              <div className={styles.list_detail}>
                <ul>
                  {bookingCode && (
                    <li>
                      <span className={styles.column_left}>Mã phiếu: </span>
                      {bookingCode}
                    </li>
                  )}

                  {serviceName && (
                    <li>
                      <span className={styles.column_left}>Dịch vụ:</span>
                      <b>{serviceName}</b>
                    </li>
                  )}

                  {bill?.bookingInfo?.implementLocation && (
                    <li>
                      <span className={styles.column_left}>Nơi thực hiện:</span>
                      <b className={styles.value}>
                        {bill?.bookingInfo?.implementLocation}
                      </b>
                    </li>
                  )}

                  {bill?.bookingInfo?.implementAgent && (
                    <li>
                      <span className={styles.column_left}>
                        Đơn vị thực hiện:
                      </span>
                      <b className={styles.value}>
                        {bill?.bookingInfo?.implementAgent}
                      </b>
                    </li>
                  )}

                  {bill?.checkInRoom?.name && (
                    <li>
                      <span className={styles.column_left}>
                        Phòng thực hiện:
                      </span>
                      <b> {bill?.checkInRoom?.name}</b>
                    </li>
                  )}

                  {doctorName && (
                    <li>
                      <span className={styles.column_left}>
                        Bác sĩ chỉ định:
                      </span>
                      <b>{doctorName}</b>
                    </li>
                  )}

                  {status === -2 || status === 0 ? null : (
                    <>
                      <li>
                        <span className={styles.column_left}>
                          Ngày thực hiện:
                        </span>
                        <b className={styles.green}>{bookingDate}</b>
                      </li>
                      <li>
                        <span className={styles.column_left}>
                          Giờ thực hiện dự kiến:
                        </span>
                        <b className={styles.green}>{bookingTime}</b>
                      </li>
                    </>
                  )}
                  <li>
                    <span className={styles.column_left}>Phí dịch vụ:</span>
                    <b>{price}</b>
                  </li>
                  <li>
                    <span className={styles.column_left}>Đối tượng:</span>
                    <b>{insuranceCode ? " Có BHYT" : " Không có BHYT"}</b>
                  </li>
                  <CustomLine />
                  {/* phần thông tin bệnh nhân */}
                  {thongTinBenhNhan}
                </ul>
              </div>
            )}
            {/* phần thông tin phiếu khám */}
            {checkInfoBenhNhan() && (
              <div className={styles.list_detail}>
                <ul>
                  {bookingCode && (
                    <li>
                      <span className={styles.column_left}>Mã phiếu: </span>
                      {bookingCode}
                    </li>
                  )}

                  {serviceName && (
                    <li>
                      <span className={styles.column_left}>Dịch vụ:</span>
                      <b>{serviceName}</b>
                    </li>
                  )}

                  <li>
                    <span className={styles.column_left}>Hình thức khám:</span>
                    <b> {insuranceCode ? " Có BHYT" : " Không có BHYT"}</b>
                  </li>

                  {(section.name || room.sectionName) && (
                    <li>
                      <span className={styles.column_left}>Khu khám:</span>
                      <b className={styles.value}>
                        {section.name || room.sectionName}
                      </b>
                    </li>
                  )}

                  {room.name && (
                    <li>
                      <span className={styles.column_left}>Phòng khám:</span>
                      <b className={styles.value}>{room.name}</b>
                    </li>
                  )}

                  {subjectName && (
                    <li>
                      <span className={styles.column_left}>Chuyên khoa:</span>
                      <b className={styles.value}> {subjectName}</b>
                    </li>
                  )}

                  {doctorName && (
                    <li>
                      <span className={styles.column_left}>Bác sĩ:</span>
                      <b>{doctorName}</b>
                    </li>
                  )}

                  {status === -2 || status === 0 || status === 6 ? null : (
                    <>
                      <li>
                        <span className={cx(styles.title)}>Ngày khám:</span>
                        <b
                          className={cx(
                            styles.value,
                            status === 1 && styles.green
                          )}
                        >
                          {bookingDate}
                        </b>
                      </li>
                      {awaitMessage === "" && (
                        <li>
                          <span className={cx(styles.column_left)}>
                            {titleBookingTime}:
                          </span>
                          <b
                            className={cx(
                              styles.value,
                              status === 1 ? styles.green : ""
                            )}
                          >
                            {bookingTime}
                          </b>
                        </li>
                      )}
                    </>
                  )}

                  <li>
                    <span className={styles.column_left}>Phí khám:</span>
                    <b>{price}</b>
                  </li>

                  {addonServices &&
                    addonServices.map((v, i) => {
                      return (
                        <li key={i}>
                          <span className={styles.column_left}>{v.name}:</span>
                          {v.priceText}
                        </li>
                      );
                    })}

                  <CustomLine />

                  {/* phần thông tin bệnh nhân */}
                  {thongTinBenhNhan}
                </ul>
              </div>
            )}

            <CustomLine />

            {/* Phần lưu ý cuối */}
            {status === -2 || status === 0 || status === 6 ? null : (
              <>
                {(bookingNote || bookingNote) && (
                  <p className={styles.attention}>Lưu ý:</p>
                )}
                <div className={styles.note}>
                  <p>{description}</p>
                </div>
                {bookingNote && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: bookingNote
                    }}
                  />
                )}
              </>
            )}

            <div className={styles.organization}>
              <a
                href="https://medpro.vn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>Được phát triển bởi </p>
                <img
                  src="https://resource.medpro.com.vn/static/images/medpro/web/header_logo.svg"
                  alt=""
                />
              </a>
            </div>
            <CustomLine bottom />
          </div>
          <BottomNavigationNews
            {...bill}
            onCancel={() => {
              this.props.handleToggleCancelModal(partnerId, id, transactionId);
            }}
            onResendSMS={this.props.handleToggleResendSMSModal}
          />
        </div>
      );
    });
  };

  renderInformationTTCK = () => {
    const { paymentInformation } = this.props;
    const bankName = get(paymentInformation, "payment.bankInfo.name");
    const accountHolder = get(
      paymentInformation,
      "payment.bankInfo.accountHolder"
    );
    const accountNumber = get(
      paymentInformation,
      "payment.bankInfo.accountNumber"
    );
    const bankBranch = get(paymentInformation, "payment.bankInfo.bankBranch");
    return (
      <React.Fragment>
        <p>Thông tin chuyển khoản:</p>
        Ngân hàng: <b>{bankName}</b> <br />
        Tài khoản: <b>{accountHolder}</b> <br />
        Số tài khoản: <b>{accountNumber}</b> <br />
        Chi nhánh: <b>{bankBranch}</b> <br />
      </React.Fragment>
    );
  };

  renderInformationHTTT = () => {
    return (
      <React.Fragment>
        <p>Hỗ trợ thanh toán:</p>
        Liên hệ hỗ trợ <b>Zalo 0865420418</b> hoặc tổng đài <b>19002115</b> để
        được hướng dẫn thanh toán.
      </React.Fragment>
    );
  };

  renderBanner = params => {
    const { global } = this.props;
    const os = get(global, "device.os", "android");
    const urlDown = () => {
      switch (os) {
        case "android":
          return Android_MEDPRO;
        case "ios":
          return IOS_MEPRO;
        default:
          return "/";
      }
    };

    return (
      <div className={styles.banner}>
        <p className={styles.title}>Chúc mừng đặt khám thành công !</p>
        <p className={styles.subTitle}>
          Quý khách vui lòng cài đặt ứng dụng để xem chi tiết <br /> hướng dẫn
          và quản lý hồ sơ khám bệnh.
        </p>
        <div className={styles.group}>
          <div className={styles.QR}>
            <QRCode
              fgColor="#000000"
              size={90}
              value="https://qrco.de/bcQbe9"
            />
          </div>
          <div className={styles.linkDown}>
            <p>
              CHẠM ĐỂ KHÁM <br /> SCAN ĐỂ TẢI APP
            </p>
            <a
              href={urlDown()}
              target={urlDown() === "/" ? "_parent" : "_blank"}
              rel="noopener noreferrer"
            >
              <PKHBtn downloadApp> Tải ứng dụng</PKHBtn>
            </a>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { paymentInformation, loading = true } = this.props;
    const paymentMethod = get(paymentInformation, "payment.gatewayId");
    // const status = get(paymentInformation, "bookingInfo.status");
    if (loading) {
      return (
        <div className={styles.loading}>
          <MDBSpinner big crazy tag="div" />
        </div>
      );
    }

    return (
      <React.Fragment>
        {/* {status === 1 && this.renderBanner()} */}
        {paymentMethod === "wiretransfer" ? (
          <MDBAlert color="primary">{this.renderInformationTTCK()}</MDBAlert>
        ) : null}
        {this.renderMedicalBill()}
        {this.renderModalShareToPay()}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  const {
    global,
    user: { IsAuthenticated },
    totalData: { paymentInformation, loading, reviewBooking }
  } = state;
  return {
    global,
    IsAuthenticated,
    paymentInformation,
    loading,
    reviewBooking
  };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});
export default connect(
  mapStateToProps,
  {
    checkRepayment: checkRepayment,
    addScheduleRepayment: addScheduleRepayment,
    resetPayment: resetPayment
  },
  mergeProps
)(MedicalBillPrintNews);
